import React, {lazy, Suspense} from 'react'
import LoadingCircle from 'views/Loading/LoadingCircle'

const PrayerMethodDetailLazy = lazy(() =>
    import('./PrayerMethodDetail')
)

const PrayerMethodDetail = props => (
    <Suspense fallback={<LoadingCircle/>}>
        <PrayerMethodDetailLazy {...props}/>
    </Suspense>
)

export default PrayerMethodDetail
